import { useQuery } from 'react-query';
import type { QueryKey, QueryFunction } from 'react-query/types/core/types';
import type {
  UseQueryResult,
  UseQueryOptions,
} from 'react-query/types/react/types';

// useQuery with eternal cache, to avoid any re-fetch of the data
// Useful for fixed data that will never changes

const useQueryOnce = <
  TQueryFnData = unknown,
  TError = unknown,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(
  queryKey: TQueryKey,
  queryFn: QueryFunction<TQueryFnData, TQueryKey>,
  options?: Omit<
    UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
    'queryKey' | 'queryFn'
  >,
): UseQueryResult<TData, TError> =>
  useQuery<TQueryFnData, TError, TData, TQueryKey>(queryKey, queryFn, {
    cacheTime: Infinity,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    ...(options || {}),
  });

export default useQueryOnce;
